import { directRequire } from 'js/backbone/portlets';

export const getBackboneReplacerViews = () => {
    const [BaseView] = directRequire(['common_base_view']);
    const baseViewPrototype = BaseView?.prototype || {
        replacers: {}
    };

    return Object.keys(baseViewPrototype.replacers)
        .reduce((memo, name) => {
            memo[name.toLowerCase().replaceAll('_', '')] = baseViewPrototype.replacers[name];

            return memo;
        }, {});
};
